<template>
  <div class="footer">

    <div class="content">
      <div class="left-wrapper">
        <div v-for="(item,index) of groupList" :key="index" class="left-wrapper-row">
          <div class="row-title">{{ item.name }}</div>
          <div v-for="(item2) of item.children" :key="item2.name">
            <tiny-link type="info" @click="handleRoute(item2)">{{ item2.name}}</tiny-link>
          </div>
        </div>
      </div>
      <div class="right-wrapper">
        <img :src="qrcode"/>
      </div>
    </div>

    <div class="out_link">
      <template v-for="item of outLinks">
        <tiny-link type="info" class="out_link_item" :href="item.path" target="_blank">{{ item.name }}</tiny-link>
      </template>
    </div>


    <div class="footer-copyright">
      <tiny-link type="primary" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011802003016" target="_blank" class="copyright">
        <img src="@/assets/images/beian.png" height="18" class="mr5"/>
        沪公网安备 31011802003016号
      </tiny-link>
      @Copyright 2023 上海释格检测技术有限公司版权所有
      <tiny-link type="primary" href="http://beian.miit.gov.cn" target="_blank">沪ICP备1503511号-1</tiny-link>

    </div>
  </div>
</template>
<script>
import { Link } from '@opentiny/vue'
import request from "@/utils/request";

export default {
  name: "Footer",
  components: {
    TinyLink: Link
  },
  props:['qrcode','address'],
  data() {
    return {
      groupList: [],
      outLinks: [],
    };
  },
  created() {
    this.queryFooterList();
    this.queryOutLinkList();
  },
  methods:{
    async queryFooterList() {
      const {data} = await request.get("/outSiteMenu/queryFooterList")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.groupList = data.data;
      }
    },

    async queryOutLinkList() {
      const {data} = await request.get("/outSiteMenu/queryOutLinkList")
      console.log("queryOutLinkList" + data);
      console.log(data);
      if (data.code === 200 && data.data) {
        this.outLinks = data.data;
      }
    },


    handleRoute(row){
      if(row.jump === '4' || row.jump === '5'){
        window.open(row.path, '_blank');
        return;
      }
      this.$router.push({path: '/page' + row.jump , query: {id: row.id}});
    },
  },
};
</script>
<style scoped>

.footer{
  background: url(~@/assets/images/footer.png) no-repeat center;
  background-size: 100% 350px;
  position: relative;
}

.content {
  width: 1180px;
  display: flex;
  margin: 0 auto;
  padding: 40px 20px 80px;
}

.left-wrapper{
  flex: 1;
  display: flex;
  justify-content: space-around;
}

.right-wrapper{
  width: 300px;
  text-align: center;
}

.row-title{
  font-size: 18px;
  color: #fff;
}

.right-wrapper img{
  width: 100px;
  height: 100px;
}

.tiny-link.tiny-link--info{
  color: #ccc;
  padding: 15px 0 5px 0;
}

.tiny-link.tiny-link--info:hover{
  color: #fa9841;
}

.footer-copyright {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 45px;
  text-align: center;
  background: rgba(57, 58, 66, .5);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
  color: #979797;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-copyright a{
  margin: 0 15px;
}

.footer-copyright a::after{
  cursor: pointer;
  color: #4c7ee9;
}

.copyright{
  display: flex;
  align-items: center;
}

.out_link{
  padding: 0 150px 50px;
  text-align: center;
}


.out_link .out_link_item{
  margin: 0px 20px;
}
</style>

